import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { flightStatusByRouteFailure, flightStatusByRouteSuccess, flightStatusByRouteRequest } from "../slice/flightRouteStatusSlice";
const FLIGHT_STATUS_ROUTE_URL = "flight/flight-status/by-route";
const accessToken = localStorage.getItem("accesstoken");
const FlightStatusRouteData = async payload => {
  let data = {
    mode: "no-cors",
    headers: {
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "accessToken",
      "App-Authorization": accessToken || ""
    },
    loader: true
  };
  let flightStatusPayload = {
    departureDate: payload?.date,
    departure: payload?.from?.airportCode,
    arrival: payload?.to?.airportCode
  };
  const response = await api.post(FLIGHT_STATUS_ROUTE_URL, flightStatusPayload, data);
  return response;
};
function* getFlightStatusByRouteData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(FlightStatusRouteData, payload);
    yield put(flightStatusByRouteSuccess(response.data));
  } catch (error) {
    yield put(flightStatusByRouteFailure(error.message));
  }
}
export function* watchFlightStatusByRoute() {
  yield takeLatest(flightStatusByRouteRequest.type, getFlightStatusByRouteData);
}